import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Label,
  Row,
  Col
} from "reactstrap";

import Image from "react-image";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Statistics } from "components";

import { theadwebmobilerequests, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF"
};

var checkIBAN = (function() {
  // use an IIFE
  // A "constant" lookup table of IBAN lengths per country
  // (the funky formatting is just to make it fit better in the answer here on CR)
  var CODE_LENGTHS = {
    AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
    FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
    HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
    LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
    MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
    RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };

  // piece-wise mod97 using 9 digit "chunks", as per Wikipedia's example:
  // http://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
  function mod97(string) {
    var checksum = string.slice(0, 2),
        fragment;

    for(var offset = 2 ; offset < string.length ; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  // return a function that does the actual work
  return function (input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),           // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;

    // check syntax and length
    if(!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    // final check
    return mod97(digits) === 1;
  };
}());

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

class MobileWebRequestList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      servicesSize: "auto",
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      shownNotifications: [],
      popUp: null,
      viewDocuments: null,
      goToCreateCustomer: false,
      requestStatus: ""
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.searchWebMobileRequest = this.searchWebMobileRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.createServicesButtons = this.createServicesButtons.bind(this);
    this.createContentToDisplay = this.createContentToDisplay.bind(this);
    this.viewRequestDocumentsButton = this.viewRequestDocuments.bind(this);
    this.hidePopUp = this.hidePopUp.bind(this);
    this.openRequestDocuments = this.openRequestDocuments.bind(this);
    this.createWebMobileRequestsCard = this.createWebMobileRequestsCard.bind(this);
    this.changeRequestStatusView = this.changeRequestStatusView.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  changeRequestStatusView(requestStatus) {
    // console.log("######## CHANGING REQUEST STATUS #######");
    // console.log(this.props.mainState);
    this.setState({
      requestStatus: requestStatus
    });
    this.props.searchWebMobileRequests(requestStatus, false, 0, false, false, false, true);
    // alert("Pulsado " + procedureStatus);

  }
  searchWebMobileRequest() {
    if (!this.props.mainState.isSearchingWebMobileRequests)
      this.props.searchWebMobileRequests(this.state.searchQuery, null, null, true);
  }
  downloadBill(url, orderNumber, event) {
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: "GET",
      responseType: "blob" // important
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  hidePopUp() {
    this.setState({
      viewDocuments: null
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(payment) {
    let statusReady = null;
    if (payment.includes("Pendiente")) {
      statusReady = (
        <Button color="danger" size="sm">
          <i className="now-ui-icons ui-1_simple-remove" /> {payment}
        </Button>
      );
    } else {
      statusReady = (
        <Button color="primary" size="sm">
          <i className="now-ui-icons ui-1_check" /> {payment}
        </Button>
      );
    }

    return statusReady;
  }
  handleChange(field, event) {
    this.setState({ [field]: event.target.value });
  }
  viewOrderArticles(order) {
    let orderDetailContent = (
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">Concepto</th>
              <th className="text-center">Precio</th>
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    });
  }
  validateIBAN(iban) {
    return checkIBAN(iban) && iban.replace(/ /g, "").length === 24;
  }
  createServicesButtons(customer) {
    let buttons = [];
    if (!this.props.mainState.customersMobilesLoaded) {
      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          color="default"
          size="sm"
          icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      let mobilesText = null;
      if (customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[customer.id]
          .length;
        // if (mobilesQuantity > 0) mobilesText = mobilesQuantity.toString();
      }

      buttons.push(
        <Button
          key={"mobileButton" + customer.id}
          round
          icon
          color={mobilesQuantity > 0 ? "primary" : "default"}
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons tech_mobile" /> {mobilesText}
          </div>
        </Button>
      );
    }

    if (buttons.length > 0) buttons.push("  ");

    buttons.push(
      <Button
        key={"internetButton" + customer.id}
        round
        icon
        color={customer.internet_activo == "1" ? "info" : "default"}
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons location_world" />
        </div>
      </Button>
    );

    let renewalIcon = "now-ui-icons business_money-coins";
    let renewalColor = customer.renovar_activo === "1" ? (this.validateIBAN(customer.cuenta_bancaria) ? "primary" : "warning") : "danger";
    if (renewalColor === "warning" && customer.metodo_pago !== "Domiciliación bancaria") renewalColor = "primary";
    if (renewalColor === "warning" && !(customer.id in this.state.shownNotifications)) {
      let customerNameLink = 
        <Link 
          key={"enlace-" + customer.id} 
          className="txt-white" 
          to={"/clientes/fichas/".concat(customer.id)}>
            <b>
              {[customer.nombre_completo, customer.primer_apellido, customer.segundo_apellido].join(" ")}
            </b>
        </Link>;
      let notificationText = [];
      notificationText.push(customerNameLink);
      notificationText.push(" tiene mal la cuenta bancaria");
      let options = {
        place: "tr",
        message: notificationText,
        type: "warning",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 10
      };
      this.props.showNotification(options);
      let shownNotificationsAux = this.state.shownNotifications;
      shownNotificationsAux[customer.id] = true;
      this.setState({
        shownNotifications: shownNotificationsAux
      });
    }
    if (buttons.length > 0) buttons.push("  ");
    buttons.push(
      <Button
        key={"renewButton" + customer.id}
        round
        icon
        color={renewalColor}
        size="sm"
        /*onClick={() => {
          this.props.switchCustomerRenewal(customer.id, customer.renovar_activo !== "1");
        }}*/
      >
        <div>
          <i className={renewalIcon} />
        </div>
      </Button>
    );

    return buttons;
  }
  createActiveCustomerButton(customer) {
    let button = undefined;
    if (customer.renovar_activo === "1") {
      button = (
        <Button
          color="primary"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons ui-1_check" /> Activo
          </div>
        </Button>
      );
    } else {
      button = (
        <Button
          color="default"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons media-1_button-pause" /> Inactivo
          </div>
        </Button>
      );
    }

    return button;
  }
  createCoverageNetworkButton(mobilePlan) {
    let button = undefined;
    if (mobilePlan.includes("orange")) {
      button = (
        <Button
          color="warning"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          {"O"}
        </Button>
      );
    } else {
      button = (
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          {"M"}
        </Button>
      );
    }

    return button;
  }
  createViewRequestDocumentsButton(request) {
    let button = 
      <Button
        color="danger"
        size="sm"
        onClick={() => this.openRequestDocuments(request)}
      >
        <div>
          <i className="now-ui-icons education_glasses" /> Ver documentos
        </div>
      </Button>;
    return button;
  }
  checkRequestCustomerStatus(request) {
    if (request.ya_es_cliente === "si") {
      return true;
    } else {
      return false;
    }
  }
  createBuildUserButton(request) {
    let button = null;
    if (request.ya_es_cliente === "si") {
      button = 
        <Link to={"/clientes/fichas/".concat(request.id_cliente)}>
          <Button
            color="primary"
            size="sm"
            // onClick={() => this.createCustomer(request)}//createCustomerFromWebRequest
          >
            <div>
              <i className="now-ui-icons users_single-02" /> Ficha lista
            </div>
          </Button>
        </Link>;
    } else {
      button = 
        <Button
          color="info"
          size="sm"
          onClick={() => this.createCustomer(request)}//createCustomerFromWebRequest
        >
          <div>
            <i className="now-ui-icons users_single-02" /> Crear ficha
          </div>
        </Button>;
    }
    return button;
  }
  createLaunchRequest(request) {
    let button = null;
    if (this.checkRequestCustomerStatus(request)){
      button =
        <Button
          color="default"
          size="sm"
          onClick={() => this.openRequestDocuments(request)}
        >
          <div>
            <i className="now-ui-icons objects_spaceship" /> Tramitar
          </div>
        </Button>;
    }
    return button;
  }
  createCustomer(request) {
    this.props.createCustomerFromWebRequest(request);
    this.setState({
      goToCreateCustomer: true
    });
  }
  openRequestDocuments(webMobileRequest) {
    this.setState({viewDocuments: webMobileRequest});
  }
  viewRequestDocuments(webMobileRequest) {
    if (!webMobileRequest) return null;
    if (!(webMobileRequest.id in this.props.mainState.isSearchingWebMobileRequestsDocuments) ||
        webMobileRequest.id in this.props.mainState.isSearchingWebMobileRequestsDocuments &&
        !this.props.mainState.isSearchingWebMobileRequestsDocuments[webMobileRequest.id]) {
      if (!(webMobileRequest.id in this.props.mainState.webMobileRequestDocuments)) {
        this.props.getWebMobileRequestDocuments(webMobileRequest.id);
      }
    }

    let _popUp = null;
    // console.log("################## VIEW MOBILE REQUEST DOCUMENTS MAINSTATE ################");
    // console.log(this.props.mainState);
    let webMobileRequestDocuments = this.props.mainState.webMobileRequestDocuments[webMobileRequest.id];
    if (webMobileRequestDocuments) {
      let URL_front_DNI = "https://cdn.nadunet.es/cdn/" + webMobileRequestDocuments.dni_frontal_solicitud.uri.replace("public://", "");
      let URL_back_DNI = "https://cdn-2.nadunet.es/cdn/" + webMobileRequestDocuments.dni_trasero_solicitud.uri.replace("public://", "");
      _popUp = 
        <SweetAlert
          style={{ display: "block", marginTop: "-300px" }}
          title="Documentos de la solicitud"
          onConfirm={() => this.hidePopUp()}
          onCancel={() => this.hidePopUp()}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          confirmBtnText="Cerrar"
          // cancelBtnText="Cancelar"
        >
          <Row>
            <Col xs={12} md={6}>
              <Label md={12}>DNI Frontal</Label>
              <Image style={{maxWidth: "100%"}} src={URL_front_DNI} />        
            </Col>
            <Col xs={12} md={6}>
              <Label md={12}>DNI Trasero</Label>
              <Image style={{maxWidth: "100%"}} src={URL_back_DNI} />         
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Label md={12}>Firma</Label>
              <Image style={{maxWidth: "100%"}} src={webMobileRequestDocuments.firma_solicitud_base64} />           
            </Col>
          </Row>
        </SweetAlert>;
    } else {
      _popUp = 
        <SweetAlert
          style={{ display: "block", marginTop: "-250px" }}
          title="Documentos de la solicitud"
          onConfirm={() => this.hidePopUp()}
          onCancel={() => this.hidePopUp()}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          confirmBtnText="Cerrar"
          // cancelBtnText="Cancelar"
        >
          <Row>
            <Col xs={12} md={6}>
              <Label md={12}>DNI Frontal</Label>
              <div>
                <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando DNI frontal...
              </div>
            </Col>
            <Col xs={12} md={6}>
              <Label md={12}>DNI Trasero</Label>
              <div>
                <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando DNI trasero...
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Label md={12}>Firma</Label>
              <div>
                <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando firma...
              </div>
            </Col>
          </Row>
        </SweetAlert>;
    }
    return _popUp;
  }
  createRequestStatus(request) {
    let button = null;
    let buttonColor = "default";
    switch (request.estado_solicitud) {
      case "Ficha no creada":
        buttonColor = "danger";
        break;
      case "Ficha lista":
        buttonColor = "warning";
        break;
      case "SIM enviada":
        buttonColor = "info";
        break;
      case "SIM recibida":
        buttonColor = "primary";
        break;
    }
    button = 
      <Button
        color={buttonColor}
        size="sm"
        icon
        // onClick={() => this.openRequestDocuments(request)}
      >
        {/* <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
        </div> */}
      </Button>;
    return button;
  }
  createContentToDisplay(webMobileRequestsToDisplay) {
    // console.log("######### CONTENT TO DISPLAY (" + this.state.requestStatus + ") ########");
    // console.log(webMobileRequestsToDisplay);
    if (!webMobileRequestsToDisplay) return null;
    let arrayToMap = null;
    if (this.state.requestStatus) {
      arrayToMap = webMobileRequestsToDisplay;
    } else {
      arrayToMap = Object.keys(webMobileRequestsToDisplay)
      .sort(function(a, b) {
        return b - a;
      });
    }
    let contentToDisplay = (
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de solicitudes</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadwebmobilerequests.map((prop, key) => {
                    if (key === theadwebmobilerequests.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    return (
                      <th key={key} className="text-center">
                        {prop}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {arrayToMap
                  .map((webMobileRequestKey, key) => {
                    let webMobileRequest = this.state.requestStatus ? webMobileRequestKey : webMobileRequestsToDisplay[webMobileRequestKey][0];
                    // let servicesButtons = this.createServicesButtons(
                    //   customer
                    // );
                    // let activeCustomerButton = this.createActiveCustomerButton(
                    //   webMobileRequest
                    // );
                    // let formattedNumber = "";
                    // if (webMobileRequest.phone) {
                    //   formattedNumber =
                    //     webMobileRequest.phone.substring(0, 3) +
                    //     " " +
                    //     webMobileRequest.phone.substring(3, 6) +
                    //     " " +
                    //     webMobileRequest.phone.substring(6, 9);
                    // }
                    // let URL_front_DNI = "https://cdn.nadunet.es/cdn/" + webMobileRequest.dni_frontal_solicitud.uri.replace("public://", "");
                    // let URL_back_DNI = "https://cdn-2.nadunet.es/cdn/" + webMobileRequest.dni_trasero_solicitud.uri.replace("public://", "");
                    let tipo_cliente_solicitud = "";
                    if (webMobileRequest.tipo_cliente_solicitud && webMobileRequest.tipo_cliente_solicitud.length > 0) {
                      try {
                        tipo_cliente_solicitud = webMobileRequest.tipo_cliente_solicitud.charAt(0).toUpperCase() + webMobileRequest.tipo_cliente_solicitud.slice(1);  
                      } catch (error) {
                        tipo_cliente_solicitud = "";
                        console.log("##### Error tipo de cliente #####");
                        console.log(webMobileRequest.tipo_cliente_solicitud);
                      }}
                    let tipo_tramite_solicitud = "";
                    if (webMobileRequest.tipo_tramite_solicitud && webMobileRequest.tipo_tramite_solicitud.length > 0) {
                      try {
                        tipo_tramite_solicitud = webMobileRequest.tipo_tramite_solicitud.charAt(0).toUpperCase() + webMobileRequest.tipo_tramite_solicitud.slice(1);  
                      } catch (error) {
                        tipo_tramite_solicitud = JSON.stringify(tipo_tramite_solicitud);
                      }
                    }
                    return (
                      <tr key={webMobileRequest.id}>
                        {/* <td className="text-center">
                          {activeCustomerButton}
                        </td> */}
                        <td className="text-center">{this.createRequestStatus(webMobileRequest)}</td>
                        <td className="text-center">{webMobileRequest.creacion}</td>
                        <td className="text-center">{tipo_tramite_solicitud}</td>
                        <td className="text-center">{this.createCoverageNetworkButton(webMobileRequest.tarifa_movil)}</td>
                        <td className="text-center">{tipo_cliente_solicitud}</td>
                        <td className="text-center">{webMobileRequest.dni_solicitud}</td>
                        <td className="text-center">
                          {/* <Link to={"/clientes/fichas/".concat(webMobileRequest.id)}> */}
                            {webMobileRequest.nombre_completo_solicitud}{" "}
                            {webMobileRequest.primer_apellido_solicitud}{" "}
                            {webMobileRequest.segundo_apellido_solicitud}
                          {/* </Link> */}
                        </td>
                        {/*<td className="text-left">{customer.email}</td>*/}
                        <td className="text-center">{webMobileRequest.numero_contacto_solicitud}</td>
                        <td className="text-center">{webMobileRequest.observaciones_solicitud}</td>
                        <td className="text-left">
                          {this.createViewRequestDocumentsButton(webMobileRequest)}
                          {" "}
                          {this.createBuildUserButton(webMobileRequest)}
                          {" "}
                          {/* {this.createLaunchRequest(webMobileRequest)} */}
                        </td>
                        {/* <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={URL_front_DNI} /></td>
                        <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={URL_back_DNI} /></td>
                        <td className="text-center"><Image style={{maxWidth: 100, maxHeight: 50}} src={webMobileRequest.firma_solicitud_base64} /></td> */}
                        {/* order.data.map((prop, key) => {
                          if (key === thead.length - 1)
                            return (
                              <td key={key} className="text-right">
                                {prop}
                              </td>
                            );
                          return <td key={key}>{prop}</td>;
                        }) */}
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
    return contentToDisplay;
  }
  createWebMobileRequestsStyle(requestType) {
    let statistic = null;
    let requestStateColor = "default";
    let requestStateIcon = "default";
    let requestStateText = /*"Solicitudes " + */requestType.estado_solicitud;
    let isCurrentStatus = requestStateText === this.state.requestStatus;

    switch (requestType.estado_solicitud) {
      case "Ficha no creada": 
        requestStateColor = "danger";
        requestStateIcon = "ui-2_time-alarm";
        break;
      case "Ficha lista": 
        requestStateColor = "warning";
        requestStateIcon = "ui-2_settings-90";
        break;
      case "SIM enviada": 
        requestStateColor = "info";
        requestStateIcon = "shopping_delivery-fast";
        // procedureStateText = "Trámites con " + requestType.estado_tramite;
        break;
      case "SIM recibida": 
        requestStateColor = "primary";
        requestStateIcon = "ui-1_check";
        break;
      default:
    }

    if (isCurrentStatus) {
      requestStateText = 
      <span className="text-center" style={{color: "#FFF"}}>{requestStateText}</span>;
      requestStateColor = "info";
    } 

    statistic =
      <Statistics
        showIcon
        iconState={requestStateColor}
        icon={requestStateIcon}
        title={requestType.contador}
        subtitle={requestStateText}
      />;

    return statistic;
  }
  createWebMobileRequestsCard() {
    let mobileContent = [];
    if(this.props.mainState.webMobileRequestsCountLoaded && this.props.mainState.webMobileRequestsCount.length > 0){
      this.props.mainState.webMobileRequestsCount.map((requestType, key) => {
        let isCurrentStatus = requestType.estado_solicitud === this.state.requestStatus;
        mobileContent.push(
          <Col xs={12} md={this.state.servicesSize} key={requestType.estado_solicitud}>
            <Card className="card-stats card-raised"
              onClick={() => {this.changeRequestStatusView(requestType.estado_solicitud)}}
              style={{cursor: "pointer"}}
              color={isCurrentStatus ? "primary" : ""}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    {this.createWebMobileRequestsStyle(requestType)}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.webMobileRequestsCountLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ninguna solicitud"
        />;
    } else {
      mobileContent.push(
        <Col xs={12} md={this.state.servicesSize} key="cargando-solicitudes">
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Cargando..."
                    subtitle="Solicitudes"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    let sortedMonths = this.props.mainState.customersLastMonths.sort(
      (a, b) =>
        new Date(...a.month.split("-").reverse()) -
        new Date(...b.month.split("-").reverse())
    );
    let popUp = this.viewRequestDocuments(this.state.viewDocuments);
    //console.log(sortedMonths);
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    if (this.state.goToCreateCustomer === true) {
      this.redirectTo("/clientes/crear");
      // return <Redirect to="/clientes/crear" />;
    }
    //console.log(this.props.mainState.customers);
    //console.log(this.props.mainState.customers.length);
    //if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadCustomersChart();
    let contentToDisplay = null;
    let webMobileRequestsToDisplay = null;

    if (!this.state.requestStatus) {
      if (
        !this.props.mainState.isSearchWebMobileRequestsResult &&
        this.props.mainState.webMobileRequestsLoaded &&
        Object.keys(this.props.mainState.webMobileRequests).length > 0
      ) {
        webMobileRequestsToDisplay = this.props.mainState.webMobileRequests;
        //console.log("######## CUSTOMERS TO DISPLAY #######");
        //console.log(customersToDisplay);
        contentToDisplay = this.createContentToDisplay(webMobileRequestsToDisplay);
      } else if (
        this.props.mainState.isSearchWebMobileRequestsResult &&
        this.props.mainState.webMobileRequestsLoaded &&
        this.props.mainState.searchWebMobileRequestsQuery in
          this.props.mainState.webMobileRequestsSearchResult &&
        Object.keys(
          this.props.mainState.webMobileRequestsSearchResult[
            this.props.mainState.searchWebMobileRequestsQuery
          ]
        ).length > 0
      ) {
        webMobileRequestsToDisplay = this.props.mainState.webMobileRequestsSearchResult[
          this.props.mainState.searchWebMobileRequestsQuery
        ];
        //console.log("######## CUSTOMERS TO DISPLAY #######");
        //console.log(customersToDisplay);
        contentToDisplay = this.createContentToDisplay(webMobileRequestsToDisplay);
      } else if (
        !this.props.mainState.isSearchWebMobileRequestsResult &&
        this.props.mainState.webMobileRequestsLoaded &&
        Object.keys(this.props.mainState.webMobileRequests).length == 0
      ) {
        contentToDisplay = (
          <SweetAlert
            danger
            style={{ display: "block", marginTop: "-250px" }}
            title="¡No hay solicitudes!"
            onConfirm={() => this.goToDashboard()}
            onCancel={() => this.goToDashboard()}
            confirmBtnBsStyle="info"
          >
            Todavía no hay ninguna solicitud, tan pronto como las haya,
            aparecerán aquí.
          </SweetAlert>
        );
      } else if (
        this.props.mainState.isSearchWebMobileRequestsResult &&
        this.props.mainState.webMobileRequestsLoaded &&
        this.props.mainState.searchWebMobileRequestsQuery in
          this.props.mainState.webMobileRequestsSearchResult &&
        Object.keys(
          this.props.mainState.webMobileRequestsSearchResult[
            this.props.mainState.searchWebMobileRequestsQuery
          ]
        ).length == 0
      ) {
        contentToDisplay = this.createContentToDisplay(webMobileRequestsToDisplay);
      } else {
        contentToDisplay = (
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="¡Un momentito!"
            onConfirm={() => this.hideAlert()}
            showConfirm={false}
          >
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
            {"  Cargando solicitudes..."}
          </SweetAlert>
        );
      }
    } else {
      if (this.props.mainState.webMobileRequestsLoaded &&
        this.state.requestStatus in this.props.mainState.webMobileRequestsByStatus &&
        this.props.mainState.webMobileRequestsByStatus[this.state.requestStatus].length > 0) {
          webMobileRequestsToDisplay = this.props.mainState.webMobileRequestsByStatus[this.state.requestStatus];
          //console.log("######## CUSTOMERS TO DISPLAY #######");
          //console.log(customersToDisplay);
          contentToDisplay = this.createContentToDisplay(webMobileRequestsToDisplay);
      } 
    }

    let orderArticles = (
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>
    );

    // let createCustomerButton = (
    //   <Link to={"/clientes/crear"}>
    //     <Button round color="info">
    //       <i className="now-ui-icons ui-1_simple-add" /> Crear cliente
    //     </Button>
    //   </Link>
    // );
    return (
      <div>
        <PanelHeader
          size="sm"
          /* content={
            <div className="header text-center">
              <h2 className="title">Lista de clientes</h2>
              {<p className="category"></p>}
            </div>
          }*/
        />
        <div className="content">
          {popUp}
          <Row>
            {this.createWebMobileRequestsCard()}
          </Row>
          <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input
                    type="text"
                    placeholder="Buscar solicitud..."
                    value={this.state.searchQuery}
                    onChange={e => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if (e.keyCode == 13) {
                        //Enter is key code 13
                        this.searchWebMobileRequest();
                        // put the login here
                      }
                    }}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingWebMobileRequests
                        ? "default"
                        : "primary"
                    }
                    round
                    icon
                    onClick={this.searchWebMobileRequest}
                  >
                    <i
                      className={
                        this.props.mainState.isSearchingWebMobileRequests
                          ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin"
                          : "now-ui-icons ui-1_zoom-bold"
                      }
                    />
                  </Button>
                </CardBody>
              </Card>
            </Col>
            {/* <Col lg={3} md={6} xs={12}>
              {createCustomerButton}
            </Col> */}
            {/*<Label sm={2}>Buscar</Label>*/}
          </Row>
          <Row>
            {this.state.showDetail && orderArticles}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default MobileWebRequestList;



// WEBPACK FOOTER //
// ./src/views/Web/MobileWebRequestList.jsx